import React, { FC } from 'react'

import clsx from 'clsx'

import { DecorationTitle } from 'src/components/atoms'
import { ApprovalRequestTable } from 'src/components/organisms/approvalRequests/ApprovalRequestTable'

import { MyReviewingConfirmationEntity } from 'src/types'

type Props = {
  myReviewingConfirmations: MyReviewingConfirmationEntity[]
  className?: string
}

export const ApprovalRequest: FC<Props> = ({ myReviewingConfirmations, className }) => {
  return (
    <div className={className}>
      <DecorationTitle sizeType="l">承認依頼</DecorationTitle>

      <div
        className={clsx(
          'tw-overflow-auto tw-mt-s0 tw-rounded-t-[4px]',
          'tw-max-h-[350px]' // 申請数が多い場合に対応するため高さを指定
        )}
      >
        <ApprovalRequestTable
          myReviewingConfirmations={myReviewingConfirmations}
          className="tw-w-fit"
        />
      </div>
    </div>
  )
}
